document.addEventListener('DOMContentLoaded', () => {
  if (typeof Swiper === 'undefined') return;

  const sliders = document.querySelectorAll('.feat-cat-slider');

  const initSlider = (el) => {
    const wrapper = el.querySelector('.swiper-wrapper');
    const slides = wrapper.querySelectorAll('.swiper-slide');

    if (slides.length > 0 && slides.length <= 6) {
      slides.forEach((slide) => {
        wrapper.appendChild(slide.cloneNode(true));
      });
    }

    wrapper.style.transitionTimingFunction = 'linear';

    const swiper = new Swiper(el, {
      slidesPerView: 2.2,
      spaceBetween: 16,
      loop: true,
      speed: 6000,
      resizeObserver: false,
      autoplay: {
        delay: 0,
        disableOnInteraction: false,
      },
      mousewheel: {
        forceToAxis: true,
        releaseOnEdges: true,
      },
      breakpoints: {
        750: { slidesPerView: 4, spaceBetween: 24 },
        990: { slidesPerView: 6, spaceBetween: 24 },
      },
      a11y: { enabled: true },
    });

    el.addEventListener('mouseenter', () => {
      const currentTranslate = swiper.getTranslate();
      swiper.setTransition(0);
      swiper.setTranslate(currentTranslate);
      swiper.autoplay.stop();
    });

    el.addEventListener('mouseleave', () => {
      swiper.setTransition(swiper.params.speed);
      swiper.slideToLoop(swiper.realIndex, swiper.params.speed, false);
      swiper.autoplay.start();
    });

    const resumeAutoplay = () => {
      swiper.setTransition(swiper.params.speed);
      if (!swiper.autoplay.running) swiper.autoplay.start();
    };

    swiper.on('touchEnd', resumeAutoplay);
    swiper.on('scroll', resumeAutoplay);
  };

  sliders.forEach((el) => {
    if (!('IntersectionObserver' in window)) {
      initSlider(el);
      return;
    }
    const observer = new IntersectionObserver((entries) => {
      if (!entries.some((entry) => entry.isIntersecting)) return;
      observer.disconnect();
      initSlider(el);
    }, { rootMargin: '200px 0px' });
    observer.observe(el);
  });
});
